import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" {...props}>
    <path fill="currentColor" d="M2.5 9.544h20v5h-20v-5Z" />
    <path fill="currentColor" d="M10 2.044h5v20h-5v-20Z" />
  </svg>
);
export default SvgComponent;
